import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class CaddeSokakAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "CaddeSokakListe";
        super(baseUrl);
    }


    getCaddeSokakListe(caddeSokakKodu?: number, mahalleKodu?: number) {

        return this.get("", { params: { caddeSokakKodu: caddeSokakKodu, mahalleKodu: mahalleKodu } });


    }

}
export default new CaddeSokakAPI();